module.exports = __webpack_public_path__ + "wordCrissCrossInTop.gif";